var _path, _g, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 53,
    viewBox: "8 5 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2125_3403",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 10,
    width: 27,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10H41.7276V39.9486H15V10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2125_3403)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9389 20.6398C20.9389 20.5554 20.9302 20.4728 20.9166 20.3923H23.9307C23.9172 20.4728 23.9084 20.5554 23.9084 20.6398V32.5174H20.9389V20.6398ZM28.3625 13.2343L35.0631 17.4229H21.6621L28.3625 13.2343ZM29.8473 32.5174H26.8779V20.6398C26.8779 20.5554 26.8691 20.4728 26.8556 20.3923H29.8696C29.8561 20.4728 29.8473 20.5554 29.8473 20.6398V32.5174ZM35.7863 20.6398V32.5174H32.8165V20.6398C32.8165 20.5554 32.8081 20.4728 32.7945 20.3923H35.8086C35.795 20.4728 35.7863 20.5554 35.7863 20.6398ZM40.2404 32.5174H38.7555V20.6398C38.7555 20.5554 38.747 20.4728 38.7332 20.3923H40.2404C40.9025 20.3923 41.4847 19.9543 41.6703 19.3177C41.8527 18.6805 41.5901 18.0006 41.0288 17.6485L29.151 10.225C28.6683 9.925 28.058 9.925 27.5772 10.225L15.6996 17.6485C15.1367 18.0006 14.8752 18.6805 15.0581 19.3177C15.2405 19.9543 15.8227 20.3923 16.4849 20.3923H17.9918C17.9782 20.4728 17.9695 20.5554 17.9695 20.6398V32.5174H16.4849C15.6653 32.5174 15 33.1827 15 34.0023V38.4563C15 39.2759 15.6653 39.9412 16.4849 39.9412H16.5913C16.6412 39.9462 16.6914 39.9486 16.7424 39.9486H19.7575C20.5771 39.9486 21.2421 39.2838 21.2421 38.4643C21.2421 37.6445 20.5771 36.9794 19.7575 36.9794H19.1612V36.9717H17.9695V35.4871H38.7555V36.9717H29.9766V36.9794H25.1745C24.355 36.9794 23.6899 37.6445 23.6899 38.4643C23.6899 39.2838 24.355 39.9486 25.1745 39.9486H37.2202C37.2714 39.9486 37.3216 39.9462 37.3715 39.9412H40.2404C41.0599 39.9412 41.7252 39.2759 41.7252 38.4563V34.0023C41.7252 33.1827 41.0599 32.5174 40.2404 32.5174Z",
    fill: "#DDDDDD"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 19.5H49.5",
    stroke: "#16A035",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24.5L52 19.5L47 14.5",
    stroke: "#16A035",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 29.5H48.5",
    stroke: "#16A035",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 34.5L36 29.5L41 24.5",
    stroke: "#16A035",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transfer_icon.46ce14374831f43a5dfa1e444b63a4c7.svg";
export { ForwardRef as ReactComponent };